/**
 * src/utils/authOffline.js
 * Utilidad para manejar autenticación local cuando no hay conexión.
 */

const STORAGE_KEY = 'offline_auth_vault';

/**
 * Genera un Hash SHA-256 de la contraseña con el email como sal.
 */
async function hashPassword(email, password) {
  const msgUint8 = new TextEncoder().encode(email.toLowerCase() + password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Guarda las credenciales hasheadas localmente tras un login exitoso online.
 */
export const saveOfflineCredentials = async (email, password, uid) => {
  try {
    const hash = await hashPassword(email, password);
    const vault = {
      uid,
      email: email.toLowerCase(),
      hash,
      timestamp: Date.now()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(vault));
  } catch (error) {
    console.error('Error al guardar credenciales offline:', error);
  }
};

/**
 * Verifica si las credenciales ingresadas coinciden con la bóveda local.
 */
export const verifyOfflineCredentials = async (email, password) => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return { error: 'no-vault' };

    const vault = JSON.parse(stored);
    if (vault.email !== email.toLowerCase()) return { error: 'wrong-user' };

    const hash = await hashPassword(email, password);
    if (hash === vault.hash) {
      return { uid: vault.uid, email: vault.email };
    }
    return { error: 'wrong-password' };
  } catch (error) {
    console.error('Error al verificar credenciales offline:', error);
    return { error: 'system-error' };
  }
};

/**
 * Borra las credenciales offline (ej. al cerrar sesión explícitamente online).
 */
export const clearOfflineCredentials = () => {
  // ATENCIÓN: No borramos offline_auth_vault para que el usuario pueda
  // volver a iniciar sesión offline incluso después de haber cerrado sesión.
  // localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem('offline_session_active');
};
